import React from "react";
import PropTypes from "prop-types";
import "./ActionGroup.scss";

const ActionGroup = ({ children }) => {
  return <div className="action-group">{children}</div>;
};

ActionGroup.propTypes = {
  children: PropTypes.node,
};

export default ActionGroup;
